import React from "react";
import { Card } from "react-bootstrap";

//
import cardCss from "./_card.scss";

export function Cards({
  options = [],
  classes = "",
  bodyTemplate = () => {},
  titleTemplate = () => {},
  dividerTemplate = <></>,
  classForPadding = false
}) {
  return (
    <Card className={`card-container ${classes}`}>
      {options.map(val => {
        return (
          <Card.Body
            className={
              classForPadding &&
              val.title
                .trim()
                .split(/\s+/)
                .filter(Boolean).length <= 8
                ? "padding-bottom-0"
                : ""
            }
          >
            <Card.Title>{titleTemplate(val) || val.title}</Card.Title>
            <Card.Text>{bodyTemplate(val) || val.text}</Card.Text>
          </Card.Body>
        );
      })}
      {dividerTemplate}
    </Card>
  );
}
